const NUMBER_LOCALE = 'fi-FI'

export const formatNumber = (value: number): string =>
  new Intl.NumberFormat(NUMBER_LOCALE).format(value)

export const formatPercent = (value: number): string =>
  new Intl.NumberFormat(NUMBER_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number.isFinite(value) ? value : 0)
